import axios from "axios";
import  { config }  from "./config";
import { mapValues, isEmpty, isString, isObject } from "lodash/fp";
export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: options.baseURL ? options.baseURL : config.baseURL,
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials,
      transformRequest: config.transformRequest,
    });

    // 请求拦截器
    instance.interceptors.request.use(
      (config) => {
        if (config.method === "post") {
          if (config.data instanceof Object) {
            config.data = mapValues((v) => {
              if (isString(v) && isEmpty(v)) {
                return null
              }
              if (isObject(v) && isEmpty(v)) {
                
                return null
              }
              return  v;
            })(config.data);
          }
        }
        if (config.method === "get") {
          let url = config.url;
          for (const k in config.data) {
            url +=
              (url.indexOf("?") !== -1 ? "&" : "?") +
              k +
              "=" +
              encodeURI(config.data[k]);
          }
          config.url = url;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    );

    // 响应拦截器
    instance.interceptors.response.use(
      (response) => {
        let data;

        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        // 用于处理blob类型的响应 by JiangLing -- 针对Excel等文件类型的响应需要用该类型接收
        if (response.config.responseType === "blob") {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          const contentDisposition = response.headers["content-disposition"];
          const patt = /filename=([^;]+\\.[^\\.;]+);*/;
          const result = patt.exec(contentDisposition);
          const filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        } else {
          if (!response.data) {
            data = JSON.parse(response.request.responseText);
          } else {
            data = response.data;
          }
        }
        return data;
      },
      (err) => {
        console.log(err);
        if (
          err.code === "ECONNABORTED" ||
          err.message === "Network Error" ||
          err.message.includes("timeout")
        ) {
            vue.$toast({
                message: "加载失败，请退出重试!",
                overlay: true,
                closeOnClickOverlay: true,
                duration: 10000,
                // onClose:function(){
                //     location.reload()
                // }
            });
        }
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = "请求错误";
              break;
            case 401:
              err.message = "未授权，请登录";
              break;
            case 403:
              err.message = "拒绝访问";
              break;
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`;
              break;
            case 408:
              err.message = "请求超时";
              break;
            case 500:
              err.message = "服务器内部错误";
              break;
            case 501:
              err.message = "服务未实现";
              break;
            case 502:
              err.message = "网关错误";
              break;
            case 503:
              err.message = "服务不可用";
              break;
            case 504:
              err.message = "网关超时";
              break;
            case 505:
              err.message = "HTTP版本不受支持";
              break;
            default:
          }
        }
        return Promise.reject(err); // 返回接口返回的错误信息
      }
    );

    // 发起请求
    instance(options)
      .then((res) => {
        resolve(res);
        return false;
      })
      .catch((error) => {
        reject(error);
      });
  });
}
